import { render, staticRenderFns } from "./Revisionmedica.vue?vue&type=template&id=1d517bcc"
import script from "./Revisionmedica.vue?vue&type=script&lang=js"
export * from "./Revisionmedica.vue?vue&type=script&lang=js"
import style0 from "./Revisionmedica.vue?vue&type=style&index=0&id=1d517bcc&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports